// extracted by mini-css-extract-plugin
export var active = "_fl-7";
export var blink = "_fl-8";
export var dropDownSelector = "_fl-4";
export var dropDownWrapper = "_fl-3";
export var fakeCursor = "_fl-6";
export var fontSizeButton = "_fl-9";
export var formQuillEditor = "_fl-0";
export var pressed = "_fl-a";
export var qlBlank = "_fl-1";
export var textFormattingToolbar = "_fl-2";
export var textToolbarOption = "_fl-5";